module.exports = __webpack_public_path__ + "static/media/CW.93e442a0.svg";